module.exports = __webpack_public_path__ + "img/featured_event.7e422f1.webp";